import React from "react";
import { Table } from "react-bootstrap";
import { FieldInputNumber } from "../Forms";
import { Field } from "formik";

const HoursComponent = (props) => {
  const { statusList, handleChange, valueArray, isSave, isEdit, name } = props;
  return (
    <Table responsive size="sm" className="hours-table-vesting">
      <thead>
        <tr>
          {statusList?.map((status) => (
            <th>{status?.employmentStatusName}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr>
          {statusList?.map((status, index) => {
            var ind = valueArray[name]?.findIndex(
              (x) => x.employmentStatusId == status.id
            );
            ind = ind != -1 ? ind : index;
            valueArray[name][ind] = {
              ...valueArray[name][ind],
              employmentStatusId: status.id,
            };
            return (
              <td>
                <Field
                  size="xs"
                  isRequired
                  placeholder=""
                  value={valueArray[name][ind].hoursOfService}
                  name={`${name}.${ind}.hoursOfService`}
                  type="number"
                  onChange={handleChange}
                  disabled={isEdit && !isSave}
                  component={FieldInputNumber}
                  autoComplete="off"
                />
              </td>
            );
          })}
        </tr>
      </tbody>
    </Table>
  );
};

export default HoursComponent;
